import { http } from '../utils/http';

// 判断联系人姓名是否已经存在
export const reqJudgeContactExisted = params =>
  http.request({
    url: `/alert/exist/${params.type}`,
    method: 'GET',
    params,
    withUserId: 'PARAMS'
  });

// 查询联系人列表
export const reqFetchContacts = params =>
  http.request({
    url: `/alert/contact`,
    method: 'GET',
    params,
    withUserId: 'PARAMS'
  });

// 创建联系人
export const reqCreateContact = data =>
  http.request({
    url: `/alert/contact`,
    method: 'POST',
    data,
    withUserId: 'DATA'
  });

// 编辑联系人
export const reqUpdateContact = data =>
  http.request({
    url: `/alert/contact`,
    method: 'PUT',
    data
  });

// 查询联系人详情
export const reqShowContact = contactId =>
  http.request({
    url: `/alert/contact/${contactId}`,
    method: 'GET'
  });

// 删除联系人
export const reqDestroyContact = params =>
  http.request({
    url: `/alert/contact`,
    method: 'DELETE',
    params
  });

export const reqFetchWorkWxContacts = () =>
  http.request({
    url: `/alert/contact/workwx`,
    method: 'GET'
  });

export const reqShowWorkWxContact = workWxUserId =>
  http.request({
    url: `/alert/contact/workwx/${workWxUserId}`,
    method: 'GET'
  });
